import React from 'react';

import './index.sp.scss';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpMarketPrice from 'components/molecules/SpMarketPrice';
import TypeRadio from 'components/atoms/Input/TypeRadio';
import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import TextAreaBox from 'components/atoms/Input/TextAreaBox';
import PcErrorArea from 'components/molecules/PcErrorArea';

const PresentSP = ({ 
  onClickMainButton,
  valid,
  experienceObject,
  qualificationObject,
  qualificationTextObject,
  isApiError,     
  hourSalaryLoading,
  errorDispMap,
  lpMode,
}) => (
  <div className="Skill SP">
    <SpBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton} 
      valid={valid}
      isApiError={isApiError}
      lpMode={lpMode}
    >
      <div className="skill-wrapper">
        <div className="title">
          {experienceObject.title}
        </div>
        <div className="check-experience">
          {experienceObject.dataList.map((label)=>{
            return(
              <TypeRadio
                key={label.label}
                value={label.value}
                onChange={experienceObject.onChange}
                checked={experienceObject.data === label.value}
                label={label.label}
              />
            );
          })}
        </div>

        <div className="mT30">
          <div className="title">
            {qualificationObject.title}
          </div>
          <div className="select-qualification">
            {qualificationObject.dataList.map((label) => {
              return (
                <NormalCheckBoxInput
                  id={label.value}
                  key={label.label}
                  type="normal"
                  checked={qualificationObject.data.includes(label.value)}
                  label={label.label}
                  onChange={qualificationObject.onChange}
                  value={label.value}
                  color="0"
                />
              );
            })}
          </div>
        </div>

        <div className="input-qualification-text">
          <TextAreaBox
            name="qualificationText"
            value={qualificationTextObject.data}
            onChange={qualificationTextObject.onChange}
            placeholder="上記に該当しない資格"
            maxLength="100"
            inValid={!!errorDispMap.qualificationText}
          />
          <PcErrorArea position='relative' message={errorDispMap.qualificationText} />
        </div>
        
        <div className="market-price">
          {hourSalaryLoading ? (
            <SpMarketPrice
              type="loading"
            />
          ) : (
            <SpMarketPrice
              type="one"
            />
          )}
        </div>
      </div>
    </SpBasicTemplate>
  </div>
);

export default PresentSP;